import { format, isThisWeek, isToday, Locale } from 'date-fns'

export const getConversationDate = (ISOStringDate: string, locale: Locale) => {
  if (isToday(ISOStringDate)) {
    return format(ISOStringDate, 'HH:mm', { locale })
  }

  if (isThisWeek(ISOStringDate)) {
    return format(ISOStringDate, 'EEE', { locale })
  }

  return format(ISOStringDate, 'dd.MM', { locale })
}
